import React, { useEffect, useState } from 'react';
import API from '../api';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './styles.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function Orders() {
  // General filter for all fields (like Customers/Drivers)
  const applyGeneralFilter = (text) => {
    const t = (text || '').toLowerCase();
    const filtered = allOrders.filter(o => {
      return (`${o.order_number} ${o.customer_name || ''} ${o.customer_code || ''} ${o.driver_name || ''} ${o.driver_code || ''} ${o.barcode || ''} ${o.pickup_address || ''} ${o.delivery_address || ''} ${o.status || ''} ${o.priority || ''} ${o.description || ''}`.toLowerCase().indexOf(t) !== -1);
    });
    setOrders(filtered.slice(0,10));
  };

  const [orders, setOrders] = useState([]);
  const [allOrders, setAllOrders] = useState([]);
  const [filterText, setFilterText] = useState('');
  const [customers, setCustomers] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [editing, setEditing] = useState(null);
  const { t, i18n } = useTranslation();
  const lang = i18n.language || 'en';

  const [customerId, setCustomerId] = useState('');
  const [deliveryCustomerId, setDeliveryCustomerId] = useState('');
  const [driverId, setDriverId] = useState('');
  const [pickupAddress, setPickupAddress] = useState('');
  const [deliveryAddress, setDeliveryAddress] = useState('');
  const [status, setStatus] = useState('pending');
  const [priority, setPriority] = useState('normal');
  const [description, setDescription] = useState('');
  const [weight, setWeight] = useState('');
  const [value, setValue] = useState('');
  const [scheduledPickup, setScheduledPickup] = useState('');
  const [scheduledDelivery, setScheduledDelivery] = useState('');
  const [whatsappNotifications, setWhatsappNotifications] = useState(true);
  const [notes, setNotes] = useState('');

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const navigate = useNavigate();
  const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/login');
    };
  // Fetch orders, customers, drivers
  const fetchOrders = async () => {
    try {
      const res = await API.get('orders/');
      const list = Array.isArray(res.data) ? res.data : [];
      list.sort((a,b) => {
        const ta = a.created_at ? new Date(a.created_at).getTime() : (a.id || 0);
        const tb = b.created_at ? new Date(b.created_at).getTime() : (b.id || 0);
        return tb - ta;
      });
      setAllOrders(list);
      setOrders(list.slice(0,10));
    } catch (e) {
      setAllOrders([]);
      setOrders([]);
    }
  };
  const fetchCustomers = () => API.get('customers/').then(res => setCustomers(res.data));
  const fetchDrivers = () => API.get('drivers/').then(res => setDrivers(res.data));

  useEffect(() => {
    fetchOrders();
    fetchCustomers();
    fetchDrivers();
  }, []);

  useEffect(() => { applyGeneralFilter(filterText); }, [filterText, allOrders]);

  // فلترة حسب الحالة
  useEffect(() => {
    if (!status) {
      setOrders(allOrders.slice(0,10));
    } else {
      const filtered = allOrders.filter(o => o.status === status);
      setOrders(filtered.slice(0,10));
    }
  }, [status, allOrders]);

  // Handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      customer: customerId,
      delivery_customer: deliveryCustomerId || null,
      driver: driverId || null,
      pickup_address: pickupAddress,
      delivery_address: deliveryAddress,
      status,
      priority,
      description,
      weight: weight ? parseFloat(weight) : null,
      value: value ? parseFloat(value) : null,
      scheduled_pickup: scheduledPickup || null,
      scheduled_delivery: scheduledDelivery || null,
      whatsapp_notifications: whatsappNotifications,
      notes
    };

    if (editing) {
      API.put(`orders/${editing.id}/`, data).then(() => {
        resetForm();
        fetchOrders();
      });
    } else {
      API.post('orders/', data).then(() => {
        resetForm();
        fetchOrders();
      });
    }
  };

  const resetForm = () => {
    setEditing(null);
    setCustomerId('');
    setDeliveryCustomerId('');
    setDriverId('');
    setPickupAddress('');
    setDeliveryAddress('');
    setStatus('pending');
    setPriority('normal');
    setDescription('');
    setWeight('');
    setValue('');
    setScheduledPickup('');
    setScheduledDelivery('');
    setWhatsappNotifications(true);
    setNotes('');
  };

  const handleEdit = (order) => {
    setEditing(order);
    setCustomerId(order.customer.toString());
    setDeliveryCustomerId(order.delivery_customer ? order.delivery_customer.toString() : '');
    setDriverId(order.driver ? order.driver.toString() : '');
    setPickupAddress(order.pickup_address || '');
    setDeliveryAddress(order.delivery_address || '');
    setStatus(order.status);
    setPriority(order.priority || 'normal');
    setDescription(order.description || '');
    setWeight(order.weight ? order.weight.toString() : '');
    setValue(order.value ? order.value.toString() : '');
    setScheduledPickup(order.scheduled_pickup ? order.scheduled_pickup.split('T')[0] : '');
    setScheduledDelivery(order.scheduled_delivery ? order.scheduled_delivery.split('T')[0] : '');
    setWhatsappNotifications(order.whatsapp_notifications);
    setNotes(order.notes || '');
  };
  const handleDelete = (id) => {
    API.delete(`orders/${id}/`).then(fetchOrders);
  };

  const handleSearch = async () => {
    const params = new URLSearchParams();
    if (startDate) params.append('start_date', startDate.toISOString().slice(0,10));
    if (endDate) params.append('end_date', endDate.toISOString().slice(0,10));
    if (driverId) params.append('driver', driverId);
    if (customerId) params.append('customer', customerId);
    if (status) params.append('status', status);
    const res = await fetch(`/api/orders/?${params.toString()}`);
    const data = await res.json();
    setOrders(data);
  };

  return (
    <div className={`page-container${lang === 'ar' ? ' rtl' : ''}`}> 
      <div className="login-buttons">
        <button onClick={() => navigate('/')}>🏠 {t('Home')}</button>
        <button onClick={handleLogout}>🚪 {t('Logout')}</button>
      </div>
      <h2>{t('Orders')}</h2>

      {/* نموذج إضافة/تعديل الطلب */}
      <form onSubmit={handleSubmit} className={lang === 'ar' ? 'rtl' : ''}>
        <select value={customerId} onChange={e => setCustomerId(e.target.value)} required>
          <option value="">{t('Select Customer')}</option>
          {customers.map(c => (
            <option key={c.id} value={c.id.toString()}>{c.name}</option>
          ))}
        </select>
  
        <select value={driverId} onChange={e => setDriverId(e.target.value)}>
          <option value="">{t('Select Driver')}</option>
          {drivers.map(d => (
            <option key={d.id} value={d.id.toString()}>{d.name}</option>
          ))}
        </select>
        <input type="text" placeholder={t('Pickup Address')} value={pickupAddress} onChange={e => setPickupAddress(e.target.value)} required />
        <select value={deliveryCustomerId} onChange={e => setDeliveryCustomerId(e.target.value)} required>
          <option value="">{t('Select Delivery Customer')}</option>
          {customers.map(c => (
            <option key={c.id} value={c.id.toString()}>{c.name}</option>
          ))}
        </select>
        <input type="text" placeholder={t('Delivery Address')} value={deliveryAddress} onChange={e => setDeliveryAddress(e.target.value)} required />
        <textarea placeholder={t('Description')} value={description} onChange={e => setDescription(e.target.value)} rows="3" />
        <input type="number" placeholder={t('Weight') + ' (kg)'} value={weight} onChange={e => setWeight(e.target.value)} step="0.01" />
        <input type="number" placeholder={t('Value') + ' ($)'} value={value} onChange={e => setValue(e.target.value)} step="0.01" />
        <input type="datetime-local" placeholder={t('Scheduled Pickup')} value={scheduledPickup} onChange={e => setScheduledPickup(e.target.value)} />
        <input type="datetime-local" placeholder={t('Scheduled Delivery')} value={scheduledDelivery} onChange={e => setScheduledDelivery(e.target.value)} />
        <div style={{display:'flex',alignItems:'center',gap:'10px',margin:'10px 0'}}>
          <input type="checkbox" id="whatsapp-notifications" checked={whatsappNotifications} onChange={e => setWhatsappNotifications(e.target.checked)} />
          <label htmlFor="whatsapp-notifications">📱 {t('WhatsApp Notifications')}</label>
        </div>
        <textarea placeholder={t('Notes')} value={notes} onChange={e => setNotes(e.target.value)} rows="2" />
        <select value={status} onChange={e => setStatus(e.target.value)} required>
          <option value="">{t('Status')}</option>
          <option value="pending">{t('Pending')}</option>
          <option value="confirmed">{t('Confirmed')}</option>
          <option value="assigned">{t('Assigned')}</option>
          <option value="picked_up">{t('Picked Up')}</option>
          <option value="in_transit">{t('In Transit')}</option>
          <option value="delivered">{t('Delivered')}</option>
          <option value="cancelled">{t('Cancelled')}</option>
        </select>
        <select value={priority} onChange={e => setPriority(e.target.value)} required>
          <option value="">{t('Priority')}</option>
          <option value="low">{t('Low')}</option>
          <option value="normal">{t('Normal')}</option>
          <option value="high">{t('High')}</option>
          <option value="urgent">{t('Urgent')}</option>
        </select>
        <button type="submit">{editing ? t('Update Order') : t('Add Order')}</button>
        {/* جميع الفلاتر والتصفية تحت زر الإضافة */}
        <div style={{marginTop:24, marginBottom:12, display:'flex', gap:'12px', alignItems:'center', flexWrap:'wrap'}}>
          <label style={{fontWeight:'bold'}}>{t('Filter by Status')}:</label>
          <select value={status} onChange={e => setStatus(e.target.value)} style={{minWidth:140}}>
            <option value="">{t('All')}</option>
            <option value="pending">{t('Pending')}</option>
            <option value="confirmed">{t('Confirmed')}</option>
            <option value="assigned">{t('Assigned')}</option>
            <option value="picked_up">{t('Picked Up')}</option>
            <option value="in_transit">{t('In Transit')}</option>
            <option value="delivered">{t('Delivered')}</option>
            <option value="cancelled">{t('Cancelled')}</option>
          </select>
          <input type="date" value={startDate || ''} onChange={e => setStartDate(e.target.value)} placeholder={t('Start Date')} style={{width: '140px'}} />
          <input type="date" value={endDate || ''} onChange={e => setEndDate(e.target.value)} placeholder={t('End Date')} style={{width: '140px'}} />
          <button onClick={(e) => {e.preventDefault(); const sd = startDate ? new Date(startDate) : null; const ed = endDate ? new Date(endDate) : null; const filtered = allOrders.filter(o => {if (!o.created_at) return true; const d = new Date(o.created_at); if (sd && d < sd) return false; if (ed && d > ed) return false; return true;}); setOrders(filtered.slice(0,10));}}>{t('Filter')}</button>
          <button onClick={(e) => {e.preventDefault(); setStartDate(''); setEndDate(''); setOrders(allOrders.slice(0,10));}}>{t('Clear')}</button>
          <input type="search" placeholder={t('Search...')} value={filterText} onChange={e => setFilterText(e.target.value)} style={{width: '200px'}} />
          <div style={{fontSize:12, color:'#666'}}>{t('Showing latest')} {orders.length} {t('orders')}</div>
        </div>
      </form>

      {/* ...تمت إزالة الفلاتر القديمة المكررة... */}

      {/* Orders List */}
      <ul>
        {orders.map(o => (
          <li key={o.id}>
            <div style={{border: '1px solid #ddd', padding: '15px', margin: '10px 0', borderRadius: '10px', backgroundColor: '#f9f9f9', boxShadow: '0 2px 5px rgba(0,0,0,0.1)'}}>
              <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '10px', marginBottom: '15px'}}>
                <div><strong>📋 {t('Order Number')}:</strong> {o.order_number}</div>
                <div><strong>👤 {t('Customer')}:</strong> {o.customer_name} ({o.customer_code})</div>
                {/* جهة التسليم تظهر مرة واحدة فقط هنا */}
                <div><strong>🏢 {t('Delivery Customer')}:</strong> {
                  o.delivery_customer_name
                    ? o.delivery_customer_name
                    : (customers.find(c => c.id === (o.delivery_customer || o.delivery_customer_id))?.name || <span style={{color:'#888'}}>{t('Not set')}</span>)
                }
                {
                  o.delivery_customer_code
                    ? `(${o.delivery_customer_code})`
                    : (customers.find(c => c.id === (o.delivery_customer || o.delivery_customer_id))?.customer_code ? `(${customers.find(c => c.id === (o.delivery_customer || o.delivery_customer_id))?.customer_code})` : '')
                }
                </div>
                <div><strong>🚗 {t('Driver')}:</strong> {o.driver_name || t('No driver')} {o.driver_code ? `(${o.driver_code})` : ''}</div>
                <div><strong>📍 {t('Pickup Address')}:</strong> {o.pickup_address}</div>
                <div><strong>🎯 {t('Delivery Address')}:</strong> {o.delivery_address}</div>
                <div><strong>📊 {t('Status')}:</strong> 
                  <span style={{padding: '3px 8px', borderRadius: '5px', backgroundColor: (o.status && o.status.toLowerCase()) === 'delivered' ? '#28a745' : (o.status && o.status.toLowerCase()) === 'pending' ? '#ffc107' : '#17a2b8', color: 'white', marginLeft: '5px', fontSize: '12px'}}>
                    {t(`status.${o.status ? o.status.toLowerCase() : ''}`) !== `status.${o.status ? o.status.toLowerCase() : ''}`
                      ? t(`status.${o.status ? o.status.toLowerCase() : ''}`)
                      : t(o.status ? o.status.toLowerCase() : '') || t('Not set')}
                  </span>
                </div>
                <div><strong>⚡ {t('Priority')}:</strong> 
                  <span style={{padding: '3px 8px', borderRadius: '5px', backgroundColor: (o.priority && o.priority.toLowerCase()) === 'urgent' ? '#dc3545' : (o.priority && o.priority.toLowerCase()) === 'high' ? '#fd7e14' : '#6c757d', color: 'white', marginLeft: '5px', fontSize: '12px'}}>
                    {t(`priority.${o.priority ? o.priority.toLowerCase() : ''}`) !== `priority.${o.priority ? o.priority.toLowerCase() : ''}`
                      ? t(`priority.${o.priority ? o.priority.toLowerCase() : ''}`)
                      : t(o.priority ? o.priority.toLowerCase() : '') || t('Not set')}
                  </span>
                </div>
                {o.description && <div><strong>📝 {t('Description')}:</strong> {o.description}</div>}
                {o.weight && <div><strong>⚖️ {t('Weight')}:</strong> {o.weight} kg</div>}
                {o.value && <div><strong>💰 {t('Value')}:</strong> ${o.value}</div>}
                {o.barcode && <div><strong>📊 {t('Barcode')}:</strong> {o.barcode}</div>}
                {o.scheduled_pickup && <div><strong>📅 {t('Scheduled Pickup')}:</strong> {new Date(o.scheduled_pickup).toLocaleString()}</div>}
                {o.scheduled_delivery && <div><strong>📅 {t('Scheduled Delivery')}:</strong> {new Date(o.scheduled_delivery).toLocaleString()}</div>}
              </div>
              <div style={{display: 'flex', flexWrap: 'wrap', gap: '5px', justifyContent: 'center', marginTop: '10px'}}>
                <button onClick={() => handleEdit(o)} style={{backgroundColor: '#28a745', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '5px', cursor: 'pointer'}}>✏️ {t('Edit')}</button>
                <button onClick={() => handleDelete(o.id)} style={{backgroundColor: '#dc3545', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '5px', cursor: 'pointer'}}>🗑️ {t('Delete')}</button>
                <button onClick={() => window.open(`/tracking/${o.id}`, '_blank')} style={{backgroundColor: '#17a2b8', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '5px', cursor: 'pointer'}}>📍 {t('Tracking')}</button>
                <button onClick={() => window.open(`/orders/print/${o.id}`, '_blank')}>{t('Print')}</button>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Orders;
